import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";
import { ProjectsTab } from "@/components/admin/ProjectsTab";
import { CompaniesTab } from "@/components/admin/CompaniesTab";
import { PartiesTab } from "@/components/admin/PartiesTab";
import { InvitesTab } from "@/components/admin/InvitesTab";
import { EmployeesTab } from "@/components/admin/EmployeesTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { AuditTab } from "@/components/admin/AuditTab";
import { BackupsTab } from "@/components/admin/BackupsTab";

export default function Admin() {
  const { user: me } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="space-y-6" data-testid="admin-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">{t("admin.title")}</h1>
        <p className="text-sm text-slate-500">{t("admin.subtitle")}</p>
      </div>

      <Tabs defaultValue="parties">
        <TabsList className="flex-wrap" data-testid="admin-tabs">
          <TabsTrigger value="parties" data-testid="admin-tab-parties">{t("admin.tabParties")}</TabsTrigger>
          <TabsTrigger value="projects" data-testid="admin-tab-projects">{t("admin.tabProjects")}</TabsTrigger>
          <TabsTrigger value="companies" data-testid="admin-tab-companies">{t("admin.tabCompanies")}</TabsTrigger>
          <TabsTrigger value="invites" data-testid="admin-tab-invites">{t("admin.tabInvites")}</TabsTrigger>
          <TabsTrigger value="employees" data-testid="admin-tab-employees">{t("admin.tabEmployees")}</TabsTrigger>
          <TabsTrigger value="users" data-testid="admin-tab-users">{t("admin.tabUsers")}</TabsTrigger>
          <TabsTrigger value="audit" data-testid="admin-tab-audit">{t("admin.tabAudit")}</TabsTrigger>
          {me?.is_super_admin && <TabsTrigger value="backups" data-testid="admin-tab-backups">{t("admin.tabBackups")}</TabsTrigger>}
        </TabsList>

        <TabsContent value="projects" className="mt-4"><ProjectsTab /></TabsContent>
        <TabsContent value="companies" className="mt-4"><CompaniesTab /></TabsContent>
        <TabsContent value="parties" className="mt-4"><PartiesTab /></TabsContent>
        <TabsContent value="invites" className="mt-4 space-y-4"><InvitesTab /></TabsContent>
        <TabsContent value="employees" className="mt-4 space-y-4"><EmployeesTab /></TabsContent>
        <TabsContent value="users" className="mt-4"><UsersTab /></TabsContent>
        <TabsContent value="audit" className="mt-4"><AuditTab /></TabsContent>
        {me?.is_super_admin && (
          <TabsContent value="backups" className="mt-4"><BackupsTab /></TabsContent>
        )}
      </Tabs>
    </div>
  );
}
